import { html, } from 'lit-element';
import { decodeEntities } from './../../libs/utils';
const show = (value, display) => display ? display : value;
const digits = (value, nodigits, format, display) => nodigits ?
    html `` :
    html `<span class="number">
      ${show(value, display)}${decodeEntities(format)}
    </span>`;
const createLabel = (label, value, nodigits, format, display, disabled) => label.length ?
    html `<div 
          class="info-progress"
          ?disabled=${disabled}
          ><span class="label">${label}</span>
          ${digits(value, nodigits, format, display)}
        </div>` :
    html ``;
export { createLabel };
